import axios from "src/lib/axios";

export const findAllQuotationList = ({
  keyword = null,
  page = null,
  page_size = null,
}) => {
  return axios.get(
    `/quotation-draft/find-all`, {
      params: {
        keyword: keyword,
        page: page,
        page_size: page_size,
        order_case: "desc",
      }
    }
  );
};

export const findAllByAdmin = ({
  keyword = null,
  // seller = "all",
  page = null,
  page_size = null,
}) => {
  return axios.get(
    `/quotation-draft/find-all-admin`, {
      params: {
        keyword: keyword,
        // seller: seller,
        page: page,
        page_size: page_size,
        order_case: "desc",
      }
    }
  );
};

export const findAllBySeller = ({
  keyword = null,
  filter = "all",
  page = null,
  page_size = null,
}) => {
  return axios.get(
    `/quotation-draft/find-all-sale`, {
      params: {
        keyword: keyword,
        filter: filter,
        page: page,
        page_size: page_size,
        order_case: "desc",
      }
    }
  );
};

export const getAllCustomer = () => 
  axios.get(`/quotation-draft/find-all-customer`);

export const getAllServiceType = () => 
  axios.get(`/service-types/find-all`);

export const findAllSuggestDesc = ({
  type = "",
  filter = null,
}) => {
  return axios.get(
    `/suggest-description/all-desc`, {
      params: {
        type,
        filter,
      }
    }
  );
};

export const getQuotationDraftDetail = (id) => {
  return axios.get(`/quotation-draft/quotation-draft-detail/${id}`);
};

export const getGenerateDraftPdf = (id) => {
  return axios.get(`/quotation-draft/generate-pdf/${id}`);
}

export const createQuotationDraft = (data) => {
  return axios.post(`/quotation-draft/create-quotation-draft`, data);
};

export const updateQuotationDraft = (data) => {
  return axios.patch(`/quotation-draft/update-quotation-draft`, data);
}

export const approveQuotationDraft = (id, data) => {
  return axios.patch(`/quotation-draft/approve-quotation/${id}`, data);
};

export const updateStatusQuotationDraft = (id) => {
  return axios.patch(`/quotation-draft/update-status/${id}`);
};
